import * as AppConstants from 'Constants/index'

export const getNumberWithMaximumDecimals = (number) =>
    Number.parseFloat(number).toFixed(5).slice(0, -1)

export const countDecimals = (number) => {
    if (Math.floor(number) === number) return 0

    const str = number.toString()
    if (str.indexOf('.') !== -1 && str.indexOf('-') !== -1) {
        return str.split('-')[1] || 0
    } else if (str.indexOf('.') !== -1) {
        return str.split('.')[1].length || 0
    }
    return str.split('-')[1] || 0
}

export const numberFormat = (number) => {
    const truncateFractionAndFormat = (parts, digits) => {
        return parts
            .map(({ type, value }) => {
                if (type !== 'fraction' || !value || value.length < digits) {
                    return value
                }

                let retVal = ''
                for (let idx = 0, counter = 0; idx < value.length && counter < digits; idx++) {
                    if (value[idx] !== '0') {
                        counter++
                    }
                    retVal += value[idx]
                }
                return retVal
            })
            .reduce((string, part) => string + part)
    }

    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
    })

    const numberDecimals = countDecimals(number)
    if (numberDecimals > AppConstants.MAXIMUM_DECIMALS && number < 1000) {
        return getNumberWithMaximumDecimals(number)
    }

    return truncateFractionAndFormat(formatter.formatToParts(number), AppConstants.MAXIMUM_DECIMALS)
}
